'use client'

import { useParams } from 'next/navigation'
import { useMemo } from 'react'

export const useCitySlugUrlParam = () => {
    const params = useParams()

    const rawCitySlug = params.citySlug

    return useMemo(() => {
        if (typeof rawCitySlug !== 'string') return

        return rawCitySlug
    }, [rawCitySlug])
}
